"use strict";
import request from 'ks_request';

const {apiURL} = require('ks_data_protocol_ui');
const validateToken = async (token) => {
    try {
        let res = await request({
            url: `${apiURL}/rms_sql/validate_token`,
            data: {
                "token": token
            },
            method: 'POST'
        });
        return res;
    } catch (err) {
        throw err;
    }
}

export default validateToken;
